/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getAldreteScores } from 'app/entities/aldrete-score/aldrete-score.reducer';
import { getEntities as getBehaviouralPainScores } from 'app/entities/behavioural-pain-score/behavioural-pain-score.reducer';
import { getEntities as getFlaccScores } from 'app/entities/flacc-score/flacc-score.reducer';
import { getEntities as getNipsScores } from 'app/entities/nips-score/nips-score.reducer';
import { getEntities as getWongBakersPainScores } from 'app/entities/wong-bakers-pain-score/wong-bakers-pain-score.reducer';
import { getEntities as getPostOpRecoveries } from 'app/entities/post-op-recovery/post-op-recovery.reducer';
import { SedationScore } from 'app/shared/model/enumerations/sedation-score.model';
import { IntakeType } from 'app/shared/model/enumerations/intake-type.model';
import { OutputType } from 'app/shared/model/enumerations/output-type.model';
import { PainScale } from 'app/shared/model/enumerations/pain-scale.model';
import { createEntity, getEntity, reset, updateEntity } from './post-op-recovery-record.reducer';

export const PostOPRecoveryRecordUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const aldreteScores = useAppSelector(state => state.aldreteScore.entities);
  const behaviouralPainScores = useAppSelector(state => state.behaviouralPainScore.entities);
  const flaccScores = useAppSelector(state => state.flaccScore.entities);
  const nipsScores = useAppSelector(state => state.nipsScore.entities);
  const wongBakersPainScores = useAppSelector(state => state.wongBakersPainScore.entities);
  const postOpRecoveries = useAppSelector(state => state.postOpRecovery.entities);
  const postOPRecoveryRecordEntity = useAppSelector(state => state.postOPRecoveryRecord.entity);
  const loading = useAppSelector(state => state.postOPRecoveryRecord.loading);
  const updating = useAppSelector(state => state.postOPRecoveryRecord.updating);
  const updateSuccess = useAppSelector(state => state.postOPRecoveryRecord.updateSuccess);
  const sedationScoreValues = Object.keys(SedationScore);
  const intakeTypeValues = Object.keys(IntakeType);
  const outputTypeValues = Object.keys(OutputType);
  const painScaleValues = Object.keys(PainScale);

  const handleClose = () => {
    navigate(`/post-op-recovery-record${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getNurses({}));
    dispatch(getVitals({}));
    dispatch(getAldreteScores({}));
    dispatch(getBehaviouralPainScores({}));
    dispatch(getFlaccScores({}));
    dispatch(getNipsScores({}));
    dispatch(getWongBakersPainScores({}));
    dispatch(getPostOpRecoveries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.time !== undefined && typeof values.time !== 'number') {
      values.time = Number(values.time);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...postOPRecoveryRecordEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      aldreteScore: aldreteScores.find(it => it.id.toString() === values.aldreteScore?.toString()),
      behaviouralPainScore: behaviouralPainScores.find(it => it.id.toString() === values.behaviouralPainScore?.toString()),
      flaccScore: flaccScores.find(it => it.id.toString() === values.flaccScore?.toString()),
      nipsScore: nipsScores.find(it => it.id.toString() === values.nipsScore?.toString()),
      wongBakersPainScore: wongBakersPainScores.find(it => it.id.toString() === values.wongBakersPainScore?.toString()),
      postOpRecovery: postOpRecoveries.find(it => it.id.toString() === values.postOpRecovery?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          sedationScore: 'AWAKE',
          intakeType: 'BLODD',
          outputType: 'URINE',
          painScale: 'NIPS',
          ...postOPRecoveryRecordEntity,
          surgery: postOPRecoveryRecordEntity?.surgery?.id,
          nurse: postOPRecoveryRecordEntity?.nurse?.id,
          vitals: postOPRecoveryRecordEntity?.vitals?.id,
          aldreteScore: postOPRecoveryRecordEntity?.aldreteScore?.id,
          behaviouralPainScore: postOPRecoveryRecordEntity?.behaviouralPainScore?.id,
          flaccScore: postOPRecoveryRecordEntity?.flaccScore?.id,
          nipsScore: postOPRecoveryRecordEntity?.nipsScore?.id,
          wongBakersPainScore: postOPRecoveryRecordEntity?.wongBakersPainScore?.id,
          postOpRecovery: postOPRecoveryRecordEntity?.postOpRecovery?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.postOPRecoveryRecord.home.createOrEditLabel" data-cy="PostOPRecoveryRecordCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.home.createOrEditLabel">
              Create or edit a PostOPRecoveryRecord
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="post-op-recovery-record-id"
                  label={translate('tinyMedicRestApp.postOPRecoveryRecord.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.time')}
                id="post-op-recovery-record-time"
                name="time"
                data-cy="time"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.painScore')}
                id="post-op-recovery-record-painScore"
                name="painScore"
                data-cy="painScore"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.sedationScore')}
                id="post-op-recovery-record-sedationScore"
                name="sedationScore"
                data-cy="sedationScore"
                type="select"
              >
                {sedationScoreValues.map(sedationScore => (
                  <option value={sedationScore} key={sedationScore}>
                    {translate(`tinyMedicRestApp.SedationScore.${sedationScore}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.intakeType')}
                id="post-op-recovery-record-intakeType"
                name="intakeType"
                data-cy="intakeType"
                type="select"
              >
                {intakeTypeValues.map(intakeType => (
                  <option value={intakeType} key={intakeType}>
                    {translate(`tinyMedicRestApp.IntakeType.${intakeType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.intakeAmount')}
                id="post-op-recovery-record-intakeAmount"
                name="intakeAmount"
                data-cy="intakeAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.outputType')}
                id="post-op-recovery-record-outputType"
                name="outputType"
                data-cy="outputType"
                type="select"
              >
                {outputTypeValues.map(outputType => (
                  <option value={outputType} key={outputType}>
                    {translate(`tinyMedicRestApp.OutputType.${outputType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.outputAmount')}
                id="post-op-recovery-record-outputAmount"
                name="outputAmount"
                data-cy="outputAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.active')}
                id="post-op-recovery-record-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.cursor')}
                id="post-op-recovery-record-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.lastupdated')}
                id="post-op-recovery-record-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.microSec')}
                id="post-op-recovery-record-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.timestampentry')}
                id="post-op-recovery-record-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.sedationScoreValue')}
                id="post-op-recovery-record-sedationScoreValue"
                name="sedationScoreValue"
                data-cy="sedationScoreValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.painScale')}
                id="post-op-recovery-record-painScale"
                name="painScale"
                data-cy="painScale"
                type="select"
              >
                {painScaleValues.map(painScale => (
                  <option value={painScale} key={painScale}>
                    {translate(`tinyMedicRestApp.PainScale.${painScale}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-recovery-record-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.nurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="post-op-recovery-record-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-aldreteScore"
                name="aldreteScore"
                data-cy="aldreteScore"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.aldreteScore')}
                type="select"
              >
                <option value="" key="0" />
                {aldreteScores
                  ? aldreteScores.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-behaviouralPainScore"
                name="behaviouralPainScore"
                data-cy="behaviouralPainScore"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.behaviouralPainScore')}
                type="select"
              >
                <option value="" key="0" />
                {behaviouralPainScores
                  ? behaviouralPainScores.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-flaccScore"
                name="flaccScore"
                data-cy="flaccScore"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.flaccScore')}
                type="select"
              >
                <option value="" key="0" />
                {flaccScores
                  ? flaccScores.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-nipsScore"
                name="nipsScore"
                data-cy="nipsScore"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.nipsScore')}
                type="select"
              >
                <option value="" key="0" />
                {nipsScores
                  ? nipsScores.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-wongBakersPainScore"
                name="wongBakersPainScore"
                data-cy="wongBakersPainScore"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.wongBakersPainScore')}
                type="select"
              >
                <option value="" key="0" />
                {wongBakersPainScores
                  ? wongBakersPainScores.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="post-op-recovery-record-postOpRecovery"
                name="postOpRecovery"
                data-cy="postOpRecovery"
                label={translate('tinyMedicRestApp.postOPRecoveryRecord.postOpRecovery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {postOpRecoveries
                  ? postOpRecoveries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/post-op-recovery-record" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PostOPRecoveryRecordUpdate;
